import { render, staticRenderFns } from "./Assunto.vue?vue&type=template&id=ad679060&"
import script from "./Assunto.vue?vue&type=script&lang=js&"
export * from "./Assunto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Assunto.vue"
export default component.exports